import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bindAll } from '@bibliocommons/utils-react';
import { Plus } from '@bibliocommons/deprecated-base-icons';
import { bibShape, userIdentityShape, ugcAgeSuitabilityShape } from '@bibliocommons/bc-prop-types';

import FullScreenOverlay from 'app/components/deprecated/shared/FullScreenOverlay';
import shelfItemShape from 'app/shapes/shelves/shelfItemShape';
import DisplayWrapper from '../DisplayWrapper';
import DisplayActions from '../DisplayActions';
import AgeSuitabilityUGCEditor from '../UGCEditors/AgeSuitabilityUGCEditor';

import './AgeSuitabilityDisplay.scss';

export class AgeSuitabilityDisplay extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      showEditor: false
    };
  }

  openEditor() {
    this.setState({ showEditor: true });
  }

  closeEditor() {
    this.setState({ showEditor: false });
  }

  renderEditor() {
    return (
      this.state.showEditor && (
        <AgeSuitabilityUGCEditor
          bib={this.props.bib}
          shelfItem={this.props.item}
          handleClose={this.closeEditor}
          existingAgeSuitability={this.props.age}
          ageSuitabilitiesActions={this.props.ageSuitabilitiesActions}
          ageSuitabilitiesTransactions={this.props.ageSuitabilitiesTransactions}
          shelfActions={this.props.shelfActions}
          shelfTransactions={this.props.shelfTransactions}
        />
      )
    );
  }

  renderActions() {
    const { owner, bib, age, ageSuitabilitiesActions, ageSuitabilitiesTransactions } = this.props;

    if (owner.get('loggedIn')) {
      const ageSuitabilityId = age.get('id');
      const metadataId = age.get('metadataId');
      const handleRemove = () =>
        ageSuitabilitiesActions.removeAgeSuitability({
          metadataId,
          ageSuitabilityId
        });
      const isRemoving = ageSuitabilitiesTransactions.getIn([metadataId, ageSuitabilityId, 'isRemoving'], false);
      const title = bib.getIn(['briefInfo', 'title']);
      const editScreenReaderMessage = <FormattedMessage id="ada_ugc_edit_age_suitability" values={{ title }} />;
      const removeScreenReaderMessage = <FormattedMessage id="ada_ugc_remove_age_suitability" values={{ title }} />;

      return (
        <DisplayActions
          handleEdit={this.openEditor}
          handleRemove={handleRemove}
          isRemoving={isRemoving}
          editScreenReaderMessage={editScreenReaderMessage}
          removeScreenReaderMessage={removeScreenReaderMessage}
        />
      );
    }

    return null;
  }

  renderAge() {
    const age = this.props.age.get('min');

    const ageSelected =
      age > 0 ? (
        <FormattedMessage id="ugc_age_suitability_ages" values={{ age: <strong> {age} </strong>, plus: <Plus /> }} />
      ) : (
        <FormattedMessage id="ugc_age_suitability_age_all" />
      );

    return <span className="age-info">{ageSelected}</span>;
  }

  render() {
    return (
      <DisplayWrapper className="cp-ugc-age-suitability-display">
        {this.renderAge()}
        {this.renderActions()}
        <FullScreenOverlay open={!!this.state.showEditor} handleClose={this.closeEditor}>
          {this.renderEditor()}
        </FullScreenOverlay>
      </DisplayWrapper>
    );
  }
}

AgeSuitabilityDisplay.propTypes = {
  bib: bibShape.isRequired,
  owner: userIdentityShape.isRequired,
  age: ugcAgeSuitabilityShape.isRequired,
  ageSuitabilitiesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ageSuitabilitiesTransactions: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  item: shelfItemShape.isRequired
};

export default AgeSuitabilityDisplay;
